import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageSeo, normalizePath, renderSeoHead } from '../seo';

export function useSeo(pathname, post, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const template = document.createElement('template');
    template.innerHTML = renderSeoHead(getPageSeo(pathname, post));
    document.head.querySelectorAll('[data-seo]').forEach((element) => element.remove());
    document.head.appendChild(template.content);
  }, [pathname, post, enabled]);
}

export default function RouteSeo() {
  const { pathname } = useLocation();
  // Article metadata is supplied by NewsDetail once its data is available.
  useSeo(pathname, null, !/^\/news\/[^/]+$/.test(normalizePath(pathname)));
  return null;
}
